const A = 2.951823174884865e-6;
const B = 5.753298233447344e-7;
function v5(model) {
  let m = String(model || '');
  if (m.endsWith('-inpainting')) m = m.slice(0, -11);
  return ['nai-diffusion-5', 'nai-diffusion-5-full', 'nai-diffusion-5-curated'].includes(m);
}
export function estimateOfficialPoints(form) {
  const p = (form && form.parameters) || {};
  const width = Number(p.width) > 0 ? Number(p.width) : 832;
  const height = Number(p.height) > 0 ? Number(p.height) : 1216;
  const steps = Number(p.steps) > 0 ? Number(p.steps) : 28;
  const samples = Math.max(1, Math.min(4, Math.floor(Number(p.n_samples) || 1)));
  // NovelAI applies img2img strength only when an input image is present.
  // Text2img requests are always billed at strength 1.
  const strength = p.mask
    ? (p.inpaintImg2ImgStrength == null ? 1 : Math.max(0, Number(p.inpaintImg2ImgStrength)))
    : p.image
      ? (p.strength == null ? 1 : Math.max(0, Number(p.strength)))
      : 1;
  const model = form && form.model;
  // NAI5 ignores SMEA/DYN for official billing, even though the controls remain visible.
  const factor = v5(model) ? 1 : (p.sm_dyn ? 1.4 : (p.sm ? 1.2 : 1));
  let perImage;
  if (model === 'nai-diffusion-3' || model === 'nai-diffusion-furry-3') {
    const pixels = width * height;
    const raw = ((15.266497014243718 * Math.exp((pixels / 1048576) * 0.6326248927474729) - 15.225164493059737) / 28) * steps;
    perImage = Math.max(Math.ceil(raw * factor * strength), 2);
  } else {
    const pixels = Math.max(width * height, 65536);
    let base = Math.ceil(A * pixels + B * pixels * steps) * factor;
    if (v5(model)) base *= 1.5;
    perImage = Math.max(Math.ceil(base * strength), 2);
  }
  let refs = 0;
  const vibes = Array.isArray(p.reference_image_multiple) ? p.reference_image_multiple.length : 0;
  const precise = Array.isArray(p.director_reference_images) ? p.director_reference_images.length : 0;
  if (!v5(model)) refs += Math.max(0, vibes - 4) * 2 * samples;
  if (String(model || '').includes('4-5')) refs += precise * 5 * samples;
  return Math.max(0, Math.ceil(perImage * samples + refs));
}
export default estimateOfficialPoints;
